import classNames from '@/lib/misc/classNames';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Button } from '../ui/button';
import { CiWallet } from 'react-icons/ci';
import Image from 'next/image';
export const CustomConnectButton = ({
  disabled,
  buttonClassName,
  connectText,
  connectCallback
}: {
  disabled?: boolean;
  buttonClassName?: string;
  connectCallback?: () => void;
  connectText?: string;
}) => {
  return <ConnectButton.Custom data-sentry-element="unknown" data-sentry-component="CustomConnectButton" data-sentry-source-file="CustomConnectButton.tsx">
      {({
      account,
      chain,
      openChainModal,
      openConnectModal,
      authenticationStatus,
      mounted
    }) => {
      const ready = mounted && authenticationStatus !== 'loading';
      const connected = ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated');
      return <div {...!ready && {
        'aria-hidden': true,
        style: {
          opacity: 0,
          pointerEvents: 'none',
          userSelect: 'none'
        }
      }}>
            {(() => {
          if (!connected) {
            return <Button variant='pink' disabled={disabled == null ? false : disabled} onClick={() => {
              openConnectModal();
              if (connectCallback) {
                connectCallback();
              }
            }} className={classNames('font-sans', buttonClassName)}>
                    {connectText ? connectText : <>
                        <CiWallet className='h-5 w-5 mx-12 top-4' />
                        {connectText ? connectText : 'Connect a wallet'}
                      </>}
                  </Button>;
          }
          if (chain.unsupported) {
            return <Button variant='outline' className={classNames('font-sans', buttonClassName)} onClick={openChainModal}>
                    Switch Network
                  </Button>;
          }
          return <div style={{
            display: 'flex',
            gap: 12
          }}>
                  <Button variant='outline' onClick={openChainModal} className={classNames('flex items-center font-sans text-center mx-auto', buttonClassName)}>
                    {chain.hasIcon && <div style={{
                background: chain.iconBackground,
                width: 12,
                height: 12,
                borderRadius: 999,
                overflow: 'hidden',
                marginRight: 4
              }}>
                        {chain.iconUrl && <Image alt={chain.name ?? 'Chain icon'} src={chain.iconUrl} width={12} height={12} />}
                      </div>}
                    {chain.name}
                  </Button>
                </div>;
        })()}
          </div>;
    }}
    </ConnectButton.Custom>;
};